// eslint-disable-next-line @typescript-eslint/naming-convention
import jwt_decode from 'jwt-decode';
export var TokenLinkType = /*#__PURE__*/ function(TokenLinkType) {
    TokenLinkType["AccountSignUp"] = "ACCOUNT_SIGNUP";
    TokenLinkType["AccountForgot"] = "ACCOUNT_FORGOT";
    TokenLinkType["AccountInvitation"] = "ACCOUNT_INVITATION";
    TokenLinkType["ForgotPassword"] = "FORGOT_PASSWORD";
    return TokenLinkType;
}({});
export var PermissionType = /*#__PURE__*/ function(PermissionType) {
    PermissionType["UserOtp"] = "USER:OTP";
    return PermissionType;
}({});
// Narrows to LinkMagicDecoded when the payload has link_type (snake_case).
// The presence of link_type is the discriminator: legacy tokens use linkType (camelCase).
export const isLinkMagicDecoded = (decoded)=>'link_type' in decoded;
// Email from either token shape: LINK_MAGIC uses `sub`, legacy uses `emailId`.
export const getDecodedEmail = (decoded)=>isLinkMagicDecoded(decoded) ? decoded.sub : decoded.emailId;
// LINK_MAGIC types the backend /accounts/resend-magic-link re-mints (mirrors server-side
// RESENDABLE_LINK_TYPES); others (NOTIFICATION_MAGIC_LINK, ACTION_LINK) are rejected, so don't resend.
const RESENDABLE_LINK_MAGIC_TYPES = new Set([
    'ACCOUNT_CREATION',
    'ACCOUNT_ACTIVATION',
    'ACCOUNT_INVITATION',
    'PROJECT_INVITATION',
    'ACCOUNT_FORGOT',
    'ACCOUNT_REGISTERED_ALREADY'
]);
export const isResendableLinkMagic = (decoded)=>!!decoded && isLinkMagicDecoded(decoded) && RESENDABLE_LINK_MAGIC_TYPES.has(decoded.link_type);
const getDecodedValue = (token)=>{
    try {
        return jwt_decode(token);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return null;
    }
};
export const getTokenMeta = (token)=>{
    const decoded = getDecodedValue(token);
    const isExpired = decoded ? new Date((decoded === null || decoded === void 0 ? void 0 : decoded.exp) * 1000) < new Date() : false;
    return {
        decoded,
        isExpired
    };
};
// id-minted tokens serialize link_type (snake_case); legacy uses linkType (camelCase).
export const isLinkMagicToken = (token)=>{
    try {
        const decoded = jwt_decode(token);
        return typeof decoded.link_type === 'string';
    } catch (unused) {
        return false;
    }
};
